// extracted by mini-css-extract-plugin
export default {"basicTextarea":"BasicTextarea_basicTextarea__ixAbo"};